import dispatchCustomEventGlobally from 'www/utils/withDependences/dispatchCustomEventGlobally'
import { EVENTS as DIALOG_EVENTS } from 'www/vue_components/common/core/BaseDialog/constants'

function showCommonErrorDialog(errorEvent = {}) {
  const errorCode = errorEvent?.response?.status || `${errorEvent?.message || ''}`.replace(/[^\d]/g, '')
  const errorAdditionalText = errorCode ? `Если не сработает, напишите в поддержку, мы поможем.\n\nКод ошибки: ${errorCode}.` : ''

  dispatchCustomEventGlobally(DIALOG_EVENTS.open, {
    maxWidth: 304,
    title: 'У нас что-то сломалось',
    text: `Попробуйте ещё раз. ${errorAdditionalText}`,
    closeText: 'Понятно',
  })
}

export default showCommonErrorDialog
